import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import styled from '@emotion/styled'

import I18n from '../../i18n'
import useProducts from '../../lib/use-products'

import ProductsTableNative from './ProductsTableNative'

import Button from '../../components/Button'
import Section from '../../components/Section'
import Typography from '../../components/Typography'
import { Info2 } from '../../components/Icon'

import useMoney from '../../lib/use-money'

const sT = (path, args) => I18n.t(`pages.products.${path}`, args)
function ProductsNative({ plans, user }) {
  const { onSelectPlan, planButtonText } = useProducts()

  return (
    <ProductsPageWrapper>
      <Helmet>
        <title>{sT('title')}</title>
      </Helmet>

      <ProductsTableNative plans={plans} user={user} />

      <FunctionsSection mid>
        <Section.Wrapper>
          <FunctionsTable>
            <FunctionsRow>
              <TitleFunctionsCell>
                <Typography tag="h1" small>
                  {sT('functions.title')}
                </Typography>
              </TitleFunctionsCell>
              <FunctionsCell>
                <Typography tag="h2" small>
                  {sT('functions.free.headline')}
                </Typography>
                {sT('functions.free.subline')}
                <Button onClick={() => onSelectPlan('free')} outline>
                  {planButtonText('free')}
                </Button>
              </FunctionsCell>
            </FunctionsRow>
          </FunctionsTable>
        </Section.Wrapper>
      </FunctionsSection>
    </ProductsPageWrapper>
  )
}


const ProductsPageWrapper = styled.div`
  background-color: ${props => props.theme.chroma.nearlyWhite.hex()};
`

const FunctionsSection = styled(Section)`
  padding-top: 4rem;
  padding-bottom: 5rem;

  ${props => props.theme.breakpoints.tablet} {
    display: none;
  }
`

const FunctionsTable = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-flow: row;
  gap: 0.2rem;
`

const FunctionsRow = styled.div`
  display: grid;
  grid-column: 1 / 6;
  grid-template-columns: subgrid;
  grid-template-rows: subgrid;
`

const FunctionsCell = styled.div`
  text-align: ${props => (props.rowHeader ? 'left' : 'center')};
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  background-color: ${props => props.theme.chroma.white.hex()};
  display: flex;
  flex-direction: ${props => (props.rowHeader ? 'row' : 'column')};
  gap: 1rem;
  padding: 0.7rem;
  align-items: center;
  justify-content: ${props => (props.rowHeader ? 'flex-start' : 'center')};

  > *:last-child {
    margin-top: auto;
  }
`

const TitleFunctionsCell = styled(FunctionsCell)`
  background-color: transparent;
  justify-content: flex-end;
`

ProductsNative.propTypes = {
  plans: PropTypes.object.isRequired,
  user: PropTypes.object
}

export default ProductsNative
